<div class="dialog-content">
  <rt-dialog-header
    [heading]="'app.email_provider_mailbox.title' | translate"
    [subheading]="'app.email_provider_mailbox.subheading' | translate"
  />

  <rt-dialog-body variant="white" layout-vertical>
    @if (mailboxConnected && !state.editing) {
      <div>
        <rt-message variant="context-information">
          {{ 'app.email_provider_mailbox.mailbox_connected' | translate }}
        </rt-message>

        <rt-button variant="tertiary" (click)="edit()" class="mailbox-edit-button" margin-top>
          {{ 'app.email_provider_mailbox.edit_mailbox' | translate }}
        </rt-button>
      </div>
    }

    @if (!mailboxConnected || state.editing) {
      <div>
        <rt-message variant="context-warning">
          <strong>{{ 'app.email_provider_mailbox.notice' | translate }}</strong>
          <br />
          {{ 'app.email_provider_mailbox.sync_info' | translate }}
          <a
            href="{{ 'app.support_resources.mailbox_sync' | translate }}"
            target="_blank"
            class="infobox-link"
          >
            {{ 'app.email_provider_mailbox.read_more_here' | translate }}
          </a>
        </rt-message>

        @if (state.formErrors && state.formErrors.length) {
          <rt-message variant="context-error small" margin-tb>
            <ul no-margin>
              @for (error of state.formErrors; track trackByValue($index, error)) {
                <li>
                  {{ error }}
                </li>
              }
            </ul>
          </rt-message>
        }

        <form
          [formGroup]="form"
          class="select-test-wrap"
          layout-full-width
          layout-vertical
          layout-space-between
          margin-bottom-small
        >
          <rt-group margin-top>
            <rt-form-field>
              <rt-label>{{ 'app.email_provider_mailbox.email' | translate }}</rt-label>
              <rt-input
                variant="rounded"
                formControlName="email"
                [rtForceValidate]="true"
                [rtFormError]="errors"
              />
            </rt-form-field>
          </rt-group>

          <rt-group margin-top>
            <rt-form-field margin-right>
              <rt-label>{{ 'app.email_provider_mailbox.username' | translate }} </rt-label>
              <ng-container>
                <rt-icon
                  class="help-tooltip"
                  name="help-outline"
                  [rtTooltip]="'app.email_provider_mailbox.username_tooltip' | translate"
                />
              </ng-container>

              <rt-input
                variant="rounded"
                formControlName="username"
                [rtForceValidate]="true"
                [rtFormError]="errors"
              />
            </rt-form-field>

            <rt-form-field>
              <rt-label>{{ 'app.email_provider_mailbox.password' | translate }}</rt-label>
              <rt-input
                variant="rounded"
                formControlName="password"
                [rtForceValidate]="true"
                [rtFormError]="errors"
                type="password"
              />
            </rt-form-field>
          </rt-group>

          <rt-group margin-top>
            <rt-form-field margin-right>
              <rt-label>{{ 'app.email_provider_mailbox.smtp_server' | translate }}</rt-label>
              <rt-input
                variant="rounded"
                formControlName="smtpServer"
                [rtForceValidate]="true"
                [rtFormError]="errors"
              />
            </rt-form-field>

            <rt-form-field>
              <rt-label>{{ 'app.email_provider_mailbox.smtp_port' | translate }}</rt-label>
              <rt-input
                variant="rounded"
                formControlName="smtpPort"
                [rtForceValidate]="true"
                [rtFormError]="errors"
                type="number"
              />
            </rt-form-field>
          </rt-group>

          <rt-group class="checkbox-group" margin-top-small-x>
            <rt-form-field class="checkbox-field">
              <rt-checkbox formControlName="smtpUseSsl">
                {{ 'app.email_provider_mailbox.smtp_use_ssl' | translate }}
              </rt-checkbox>
            </rt-form-field>
          </rt-group>

          <rt-group margin-top>
            <rt-form-field margin-right>
              <rt-label>{{ 'app.email_provider_mailbox.imap_server' | translate }}</rt-label>
              <rt-input
                variant="rounded"
                formControlName="imapServer"
                [rtForceValidate]="true"
                [rtFormError]="errors"
              />
            </rt-form-field>

            <rt-form-field>
              <rt-label>{{ 'app.email_provider_mailbox.imap_port' | translate }}</rt-label>
              <rt-input
                variant="rounded"
                formControlName="imapPort"
                [rtForceValidate]="true"
                [rtFormError]="errors"
                type="number"
              />
            </rt-form-field>
          </rt-group>

          <rt-group class="checkbox-group" margin-top-small-x>
            <rt-form-field class="checkbox-field">
              <rt-checkbox formControlName="imapUseSsl">
                {{ 'app.email_provider_mailbox.imap_use_ssl' | translate }}
              </rt-checkbox>
            </rt-form-field>
          </rt-group>
        </form>

        <rt-group layout space-tb>
          <rt-button
            variant="primary"
            [disabled]="form.invalid"
            [loading]="state.loading"
            (click)="submit()"
            margin-right-small
          >
            {{ 'app.email_provider_mailbox.connect' | translate }}
          </rt-button>
          <rt-button variant="plain" (click)="cancelClick()">
            {{ 'app.common.cancel' | translate }}
          </rt-button>
        </rt-group>
      </div>
    }
  </rt-dialog-body>
</div>

<div class="dialog-info-box">
  <rt-heading variant="heading large light">
    <rt-icon name="info" colorToken="colorIconInfoDefault" />
    {{ 'app.email_provider_security_info.title' | translate }}
  </rt-heading>
  <p margin-top-small [innerHTML]="'app.email_provider_security_info.info' | translate"></p>

  <dl margin-tb>
    <dt>
      {{ 'app.email_provider_security_info.li_1.title' | translate }}
    </dt>
    <dd>
      {{ 'app.email_provider_security_info.li_1.description' | translate }}
    </dd>
    <!--    TODO: Uncomment when we start encrypting passwords to mailboxes-->
    <!--    <dt>-->
    <!--      {{ 'app.email_provider_security_info.li_2.title' | translate }}-->
    <!--    </dt>-->
    <!--    <dd>-->
    <!--      {{ 'app.email_provider_security_info.li_2.description' | translate }}-->
    <!--    </dd>-->
    <dt>
      {{ 'app.email_provider_security_info.li_3.title' | translate }}
    </dt>
    <dd>
      {{ 'app.email_provider_security_info.li_3.description' | translate }}
    </dd>
  </dl>
</div>
